// @flow strict
import { Button, Card, Empty, Modal, Row, Tabs, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Toaster } from 'react-hot-toast';
import { GoPlus } from "react-icons/go";
import { getAdminPricingPlans } from "../../../api/pricing";
import Coupons from "./Coupons";
import NewPricingPlan from "./NewPlan";
import AdminPlanCard from "./PlanCard";

function AdminPricingPlan() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addModal, setAddModal] = useState(false);

  const fetchPricingPlans = async () => {
    try {
      const res = await getAdminPricingPlans();
      if (res?.data?.plans) {
        setPlans(res.data.plans);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPricingPlans();
  }, []);

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="container-fluid py-4 admin-pricing-page" style={{height:"94vh"}}>
        <Tabs
          items={[
            {
              label: 'Pricing Plans',
              key: 'pricingPlan',
              children: (
                <Card title={
                  <div className="d-flex justify-content-between align-items-center py-3">
                    <h3>Pricing Plans</h3>
                    <Button onClick={() => setAddModal(true)} size="large">
                      <GoPlus />
                      <span>New Plan</span>
                    </Button>
                  </div>
                }>
                  {loading ? (
                    <div className="d-flex justify-content-center py-5">
                      <Spin size="large" />
                    </div>
                  ) : plans?.length > 0 ? (
                    <Row gutter={[16, 32]} className="pricing-cards">
                      {plans.map((plan, index) => (
                        <AdminPlanCard key={index} setPlans={setPlans} plan={plan} />
                      ))}
                    </Row>
                  ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  )}
                </Card>
              )
            },
            {
              label: 'Coupon List',
              key: 'couponList',
              children: <Coupons />
            },
          ]}
        />

      </div>
      <Modal
        title="New Pricing Plan"
        open={addModal}
        onCancel={() => setAddModal(false)}
        footer={[]}
      >
        <NewPricingPlan setPlans={setPlans} setAddModal={setAddModal} />
      </Modal>
    </>
  );
};

export default AdminPricingPlan;
